'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
import { getConsents, sendConsents } from '@src/actions/consents.actions';
import { useOnMount } from '@src/hooks/useOnMount';
import { useLocale } from '@src/i18n/LocaleProvider';
import type { Consent, GetConsentsResponse } from '@src/services/consents.service';
import { instrumentAction } from "@src/utils/instrumentation";
interface Props {
  fetchConsents?: boolean;
}
export const useConsents = props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props) {
    t0 = props ?? {};
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    fetchConsents: t1
  } = t0;
  const fetchConsents = t1 === undefined ? true : t1;
  const {
    locale
  } = useLocale();
  const [isLoading, setIsLoading] = useState(true);
  const [isSendingContent, setIsSendingConsent] = useState(false);
  const [data, setData] = useState(null);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [slugs, setSlugs] = useState(t2);
  let t3;
  if ($[3] !== fetchConsents || $[4] !== locale.code) {
    t3 = () => {
      const fetchConsentsData = async function fetchConsentsData() {
        if (!fetchConsents) {
          return;
        }
        setIsLoading(true);
        const consentsResponse = await instrumentAction("ConsentsActions.getConsents", getConsents)({
          locale: locale.code
        });
        setData(consentsResponse.data);
        setSlugs(consentsResponse.data.consents.reduce(_temp, {}));
        setIsLoading(false);
      };
      fetchConsentsData();
    };
    $[3] = fetchConsents;
    $[4] = locale.code;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useOnMount(t3);
  let t4;
  if ($[6] !== locale.code) {
    t4 = async function sendConsent(args) {
      const {
        email,
        slug,
        value
      } = args;
      setIsSendingConsent(true);
      const response = await instrumentAction("ConsentsActions.sendConsents", sendConsents)({
        locale: locale.code,
        data: {
          email,
          consentResponses: [{
            slug,
            value
          }]
        }
      });
      setIsSendingConsent(false);
      return response;
    };
    $[6] = locale.code;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const sendConsent = t4;
  let t5;
  if ($[8] !== data || $[9] !== isLoading || $[10] !== isSendingContent || $[11] !== sendConsent || $[12] !== slugs) {
    t5 = {
      data,
      slugs,
      sendConsent,
      isLoading,
      isSendingContent
    };
    $[8] = data;
    $[9] = isLoading;
    $[10] = isSendingContent;
    $[11] = sendConsent;
    $[12] = slugs;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
function _temp(slugs_0, consent) {
  slugs_0[consent.slug] = consent;
  return slugs_0;
}